<script>
import baseList from "@/views/components/base/baseList.vue";
// import baseHospital from "@/views/components/base/baseHospital.vue";
export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      commodity: "商品管理",
      shoptable: "商品列表",
      // rowClassName: () => {},
      table: {
        mname: "commodity",
        key: "id",
        url: {
          del: "/admin/commodity/delete",
        },
        output: false,
        order: "id",
        qrCode: "qrCode",
      },
      actions: [
        {
          label: "新增商品",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/commodity/add",
          type: "info",
        },
      ],
      // 菜单
      menus: [
        // { label: "商品管理", name: "commodity_list", auth: "/admin/commodity/list"},
        // { label: "分类管理", name: "commodityType_list", auth: "/admin/commodityType/list"},
        // { label: "标签管理", name: "labelType_list", auth: "/admin/labelType/list"},
        // { label: "日志管理", name: "logType_list", auth: "/admin/logType/list"},
        // { label: "物流管理", name: "logisticsType_list", auth: "/admin/logisticsType/list"},
        // { label: "订单管理", name: "ordersType_list", auth: "/admin/ordersType/list"},
      ],
      query: {
        //state: 1,
      },
      filters: [
        { label: "商品名称", name: "commodityName", value: "", type: "input" },
        // { label: "商品名称", name: "commodityName", value: "", type: "select" },
        {
          label: "商品分类",
          name: "commodityTypeId",
          value: "",
          type: "select",
          dropList: [],
        },

        // {label: '选择时间', name: '', value: '', type: 'datetimerange'},
      ],
      // 表字段
      tableCols: [
        // {
        //   type: "selection",
        //   width: 60,
        // },
        // {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "left",
        // },
        // {
        //   title: "客户ID",
        //   key: "id",
        //   minWidth: 160,
        //   align: "left",
        // },
        {
          title: "商品名称",
          key: "commodityName",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>晨光按动中性笔0.5mm黑色</p>

          // }
        },
        {
          title: "商品图片",
          key: "commodityImage",
          minWidth: 100,
          align: "center",
          viewimage: true,
          // render:()=>{
          //   const img='sp1.jpg'
          //   return<img src={img} style="width:60px;height:60px;margin:10px"/>
          // }
        },
        {
          title: "商品分类",
          key: "commodityType",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>办公室消耗品</p>
          // }
        },
        {
          title: "商品库存数量",
          key: "commodityRepertory",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>2564*盒</p>
          // }
        },

        {
          title: "价格",
          key: "commodityPrice",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>15/盒</p>
          // }
        },
        {
          title: "商品进价",
          key: "commodityCost",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>5/盒</p>
          // }
        },
        {
          title: "商品型号",
          key: "model",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>5/盒</p>
          // }
        },
        {
          title: "适用机型/场景",
          key: "enableModelScen",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>5/盒</p>
          // }
        },
        {
          title: "功能",
          key: "enableFunction",
          minWidth: 160,
          align: "center",
          // render:()=>{
          //   return <p>5/盒</p>
          // }
        },
        {
          title: "操作",
          align: "center",
          width: 260,
          key: "handle",
          // fixed: "right",
          handle: ["edit", "delete"],
          auth: {
            edit: "/admin/commodity/edit",
            del: "/admin/commodity/delete",
          },
          // render:()=>{
          //     return (
          //       <Space direction="vertical">
          //         <Space wrap>
          //             <Button>编辑</Button>
          //             <Button type="error" style="margin-left:10px">删除</Button>
          //         </Space>
          //     </Space>
          //     )
          // }
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
  },
  methods: {
    toAdd() {
      $utils.url.push({ name: "commodity_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "commodity_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/commodityType/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.commodityType;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "commodityTypeId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
  },
};
</script>
<style scoped></style>
